import { config } from "../../../../../config";
import http from "../../../../../http";
import { GET_DISTRICT_BEGIN, GET_DISTRICT_SUCCESS, CLEAR_DISTRICT } from "./type";
import { hasErrors } from "../../../error/actions";
import qs from "querystring";
export const getDistricts = (provinceId) => {
    return async dispatch => {
        try {
            dispatch(getBegin())
            const result = await http.get(config.api.COMMON.ADDRESS.GET_DISTRICTS, {
                params: { provinceId },
                paramsSerializer: (params) => {
                    return qs.stringify(params, { arrayFormat: 'brackets' })
                },
            })
            dispatch(getSuccess(result))
        } catch (error) {
            dispatch(hasErrors(error))
        }
    }
}

export const clearDistrict = () => {
    return async dispatch => {
        dispatch({ type: CLEAR_DISTRICT })
    }
}

const getBegin = () => {
    return dispatch => {
        dispatch({ type: GET_DISTRICT_BEGIN })
    }
}
const getSuccess = (items) => {
    return dispatch => {
        dispatch({ type: GET_DISTRICT_SUCCESS, payload: { items, loading: false } })
    }
}